import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import { USER } from "@types/user";
import { handleEmployeeNumberChange } from "@services/ErrorHandling";

type UserCompanyNumberCardProps = {
  userData: USER;
  updateUserData: (field: string, value: any) => void;
  errors: any;
  updateError: (field: string, value: any) => void;
};

export const UserCompanyNumberCard = ({
  userData,
  updateUserData,
  errors,
  updateError,
}: UserCompanyNumberCardProps) => {
  return (
    <div>
      <div className="w-full md:w-3/5">
        <TextInputField
          label="社員番号"
          providedClassName="form-text-field-border-full"
          value={userData?.employee_number}
          placeholder="123456"
          onChange={(e) =>
            handleEmployeeNumberChange(
              e.target.value,
              updateUserData,
              updateError,
            )
          }
        />
        {errors.employee_number && (
          <p className="text-red-500">
            {UserFieldErrorMessages.employeeNumberError}
          </p>
        )}
      </div>
      <div className="mt-5 divider"></div>
    </div>
  );
};
